var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","points":"328 112 184 256 328 400","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48"}));
}

ChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 512 512","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
